import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createSelectionList } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';

/**
 * Hook containing mutation function for creating a Selection List.
 */
export const useCreateSelectionList = () => {
  const queryClient = useQueryClient();

  return useMutation({
    /**
     * mutateFn - Function to call createSelectionList.
     * @param {Pella.ProductionRequestAPI.CreateSelectionListInput} input - The inputs for creating the Selection List.
     */
    mutationFn: (input) => createSelectionList(input),
    onSuccess: () => {
      toast.success('Selection List created successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SELECTION_LISTS] });
    },
  });
};
